import React from 'react';

import {ReactComponent as ErrorModal} from '../../assets/docs-women/error-modal.svg';

import styles from './styles/error-btn-box.module.css';

export default function ErrorBtnBox({ fileType, requestType, error, children }) {
    const errorCode = error ? error.code : null;

    const getFileType = (fileType) => {
        if (fileType === 'category') return '카테고리';
        if (fileType === 'docs') return '파일';
    };

    const getRequestType = (requestType) => {
        if (requestType === 'create') return '추가';
        if (requestType === 'update') return '수정';
    };

    return (
        <div className={styles.wrapper}>
            <div className={styles.boxError}>
                {error && <ErrorModal />}
                {errorCode === 400 &&  `중복되는 ${getFileType(fileType)} 이름입니다.`}
                {errorCode === 500 && `카테고리 ${getRequestType(requestType)} 중 오류가 발생했습니다. 문제가 지속되면 관리자에게 문의해 주세요.`}
            </div>
            {children}
        </div>
    );
}
